const AppRoute = {
  // auth
  auth: '/auth',
  // kich hoat tai khoan
  mobileApp: '/mobile_app',
  agencyApp: '/agency_app',
  // tong quan
  manageGeneralInfo: '/manage-general-info',
  dashboardList: '/dashboard-list',
  dashboard: '/dashboard',
  agencyDashboard: '/agency-dashboard',
  saleDashboard: '/agency-dashboard/sale',
  landlordDashboard: '/agency-dashboard/landlord',
  investorDashboard: '/agency-dashboard/investor',
  groupDashboard: '/agency-dashboard/group',
  superDashboard: '/soc',
  // quan ly tram sac
  manageChargeStations: '/manage-charge-stations',
  // quan ly nhan vien
  manageStaffs: '/manage-staffs',
  manageVehicles: '/manage-vehicles',
  // quan ly dich vu
  testChargeTransaction: '/test-charge-transaction',
  managePaymentTransactions: '/manage-payment-transactions',
  chargeStationsList: '/charge-stations-list',
  // ban do tram sac
  stationMap: '/station-map',
  stationsMap: '/stations-map',
  stationsMapIframe: '/stations-map-iframe',
  // quan ly mat bang
  premisesList: '/premises',
  // hoa don tien dien
  energyBillList: '/energy-bill',
  // hang san xuat tru sac
  manageChargeBrand: '/charge-brand',
  // quan ly thiet bi
  inventoryList: '/inventory',
  productCategoryList: '/product-category',
  // dinh gia sac dien
  valuationList: '/valuation',
  // quan ly xe
  manageVehicles: '/manage-vehicles',
  vehicleList: '/vehicle',
  // quan ly the rfid
  rfidList: '/rfid',
  // quan ly hang xe
  manageVehicleBrand: '/vehicle-brand',
  manageVehicleModel: '/vehicle-model',
  // quan ly phien sac
  chargeTransactionList: '/charge-transaction',
  // quan ly khach hang
  customerHome: '/customer/home',
  customerList: '/customer',
  customerDetail: '/customer/detail',
  customerProductDetail: '/customer/product/:productId',
  customerTopUpHistory: '/customer-topup',
  // quan ly dai ly
  manageDealership: '/manage-dealership',
  saleList: '/sale',
  // lich su giao dich
  managePaymentTransactions: '/manage-payment-transactions',
  commissionTransactionList: '/commission-transaction',
  withdrawTransactionList: '/withdraw-transaction',
  agencyWithdrawRequest: '/agency-withdraw-request',
  affiliateTree: '/affiliate-tree',
  // quan ly ndt va chu mat bang
  managePartners: '/manage-partners',
  // nha dau tu htkd
  groupsList: '/groups',
  groupList: '/group',
  investmentPackList: '/investment-pack',
  // nha dau tu nhuong quyen
  investorsList: '/investors',
  investorList: '/investor',
  // chu mat bang
  landlordsList: '/landlords',
  landlordList: '/landlord',
  landlordReport: '/landlord-report',
  // doi tac mua tru sac
  chargePointPartnersList: '/charge-point-partners',
  chargePointPartnerList: '/charge-point-partner',
  // bao cao doi soat
  reconciliationReport: '/reconciliation-report',
  saleReport: '/reconciliation-report/sale',
  investorReport: '/reconciliation-report/investor',
  groupReport: '/reconciliation-report/group',
  landlordReport: '/reconciliation-report/landlord',

  // he thong
  manageSystem: '/manage-system',
  // quan ly don hang admin
  orderList: '/order',
  // quan ly don hang agency
  agencyOrderList: '/agency-order',
  // quan ly nhan vien
  manageStaffs: '/manage-staffs',
  staffList: '/staff',
  // thiet lap chung
  setting: '/setting',
  pushNotificationList: '/push-notification',
  systemLogList: '/system-log',
  actionLogList: '/action-log',
  rideKyc: '/ride/kyc',
  rideDrivers: '/ride/drivers',
  rideTrips: '/ride/trips',
  rideBookings: '/ride/bookings',
  rideDemands: '/ride/demands',
  ridePricing: '/ride/pricing',
  ridePromoCodes: '/ride/promo-codes',
  rideReviews: '/ride/reviews',
  rideSupportChat: '/ride/support',
  rentalPartners: '/rental/partners',
  rentalDeposits: '/rental/deposits',
  rentalRenterLicenses: '/rental/renter-licenses',
  rentalOrders: '/rental/orders',
  rentalDamageReports: '/rental/damage-reports',
  rentalReconciliations: '/rental/reconciliations',
  rentalExpiredContracts: '/rental/expired-contracts',
  rentalVehicleModels: '/rental/vehicle-models',
  insurancePackList: '/insurance-pack',
  voucherList: '/voucher',
  withdrawTransaction: '/withdraw',
  tutorialList: '/tutorial',
  generalSetting: '/general-setting',
  premiseOrderList: '/premise-order',
  manageBanner: '/banner',
  bannerCategoryList: '/banner/category',
  bannerList: '/banner/list',

  // quan ly nhom quyen
  salePermissionList: '/permission-group/sale',
  partnerPermissionList: '/permission-group/partner',
  staffPermissionList: '/permission-group/staff',

  // quan ly nhan vien
  manageStaffAccounts: '/manage-staff-accounts',
  manageStaffChargingHistory: '/manage-staff-charging-history',
  // quan ly dich vu
  testChargeTransaction: '/test-charge-transaction',
  // quan ly nhiem vu
  // quan ly doi tac
  managePartner: '/manage-partner',
  // quan ly dai ly
  manageDealer: '/manage-dealer',
  // thong tin dai ly
  saleInfo: '/sale-info',
  // lich su giao dich
  transactionHistory: '/transaction-history',
  // lich su ban hang
  saleHistory: '/sale-history',
  // them don hang
  agencyAddOrder: '/agency-add-order',
  // don mua
  purchaseOrder: '/purchase-order',
  // don ban
  saleOrder: '/sale-order',
  manageInvestor: '/manage-investor',
  manageInvester: '/manage-invester',
  manageInvestorGroupSection: '/manage-investor-group-section',
  investorGroupList: '/investor-group-list',
  manageGroupPermissionInvestor: '/manage-investor-permission',
  manageGroupPermissionInvestorGroup: '/manage-investor-group-permission',
  // thong tin nha dau tu
  investorInfo: '/investor-info',
  manageLandowner: '/manage-landowner',
  landownerList: '/landowner-list',
  manageGroupPermissionLandlord: '/manage-landlord-permission',

  myAccount: '/my-account',

  // hop dong
  contractList: '/contract',

  // quybka
  agencySaleAddOrder: '/agency-sale-add-order',
  agencySaleOrderList: '/agency-sale-order-list',
  agencySaleOrderDetail: '/agency-sale-order',
  agencyContractList: '/agency-contract-list',
  agencyReconciliationList: '/agency-reconciliation-list',
  agencyConfigCommission: '/agency-config-commission',

  stationList: '/charge-station',
  pointList: '/charge-point',
  subSaleList: '/sub-sale',
  subInvestorList: '/sub-investor',
  investorsReport: '/investors-report',
  groupInfo: '/group-info',
  subGroupList: '/sub-group',
  groupPackHistory: '/group-pack-history',
  groupsReport: '/groups-report',
  landlordInfo: '/landlord-info',
  electricityPayment: '/electricity-payment',
  landlordsReport: '/landlords-report',
  poaContract: '/poa-contract',
  managePayments: '/manage-payments',

  marketingDocs: '/marketing-docs',
};

export default AppRoute;
